import HitProductCard from 'components/molecules/hit-product-card'
import ProductListContainer from 'components/templates/product-list-container'

import useHitProducts from 'hooks/product/use-hit-products'

type HitProductListProps = {
  openSignUp?: () => void
}

const HitProductList = ({ openSignUp }: HitProductListProps) => {
  const { hits, isLoggedIn, favouriteProducts, skusPricesByProductId, isLoading } = useHitProducts()

  return (
    <ProductListContainer numColumns={4} isLoading={isLoading}>
      {hits.map((hit) => {
        const skuPrices = skusPricesByProductId ? skusPricesByProductId[hit.sku] : undefined

        return (
          <HitProductCard
            hit={hit}
            productPrices={skuPrices}
            key={hit.productID}
            openSignUp={openSignUp}
            isLoggedIn={isLoggedIn}
            isFavourite={favouriteProducts?.some((product) => product.keyParam === skuPrices?.key)}
          />
        )
      })}
    </ProductListContainer>
  )
}

export default HitProductList
